export default  {	
	data () {
		return { 
			cardCol: 9,
			cardCol2: 3,
			cardHover: 1,
			editarDataPost: false,
			total: 0,
			active: 0,
			updates: 0,
			ultimaRazon: null,
			errorsAportes: null,
			datosAsesor: null,
		}
	},
	async created () { 
		await this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required|minIngreso'})
		await this.onInit()
	},
	destroyed()
	{
		this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required'})
	},
	methods:{
		async onInit()
		{
			this.ultimaRazon=this.dataForm[this.namePath].info_afiliacion.id_datos_razon
			const await1 = this.updateDataForm({state: 'afiliado_beneficiarios', data: []})
			const await3 = this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1}) })	
			let precios = await this.buscarIdb({tabla:'precios', campo: 'id_datos_contacto', value: 1})
        	const await4 = this.updateDataForm({state: 'precios', data: precios})
			await Promise.all([await1,await3,await4])
			
		}
	}
}
